import { ORIENTATIONS }                   from '../../constants/orientation/orientations.constant'
import { UI_SIDES }                       from '../../constants/ui/ui-sides.constant'
import { UI_ORIENTATION_ELEMENTS }        from '../../constants/ui/ui-orientation-elements.constant'
import { UI_ORIENTATION_ELEMENTS_INLINE } from '../../constants/ui/ui-orientation-elements-inline.constant'
import { UI_INTERFACES }                  from '../../constants/ui/ui-interfaces.constant'
import { Action }                         from '../action/action.class'

/**
 * @file Defines the {@link Orientation} class
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

/** Class for handling orientation */
 export class Orientation {

    /**
     * Callback function for when orientation changes
     * @memberof Orientation
     * @protected
     * @instance
     * @type {Action}
     */
    _onChange
    
    /**
     * String storing orientation
     * @memberof Orientation
     * @protected
     * @instance
     * @type {string}
     */
    _orientation

    /**
     * Initialize onChange custom event
     */
    constructor() {
        this._onChange = new Action()
    }

    /** Get onChange */    get onChange()    { return this._onChange }
    /** Get orientation */ get orientation() { return this._orientation }

    /** Set orientation */
    set orientation(v_) {
        this._orientation = v_
    }

    /** Handles updating UI styling based on orientation */
    style() {

        let o = ORIENTATIONS.filter(o_ => o_ !== this.orientation) //Retrieve old orientation

        //If mobile
        if (framework.isTouch()) {

            let elements = UI_SIDES.concat(UI_ORIENTATION_ELEMENTS) //Build array with elements that have orientation specific styling

            //Loop through all elements
            for (let i = 0; i < elements.length; i++) {

                let element = elements[i] //Retrieve element

                //If element rendered
                if (document.getElementById(element) !== null) {

                    let e = document.getElementById(element) //TODO: re write this class code is just messy

                    if (e.classList.contains(o)) {
                        e.classList.remove(o)             //Remove old orientation styling
                    }

                    e.classList.add(this.orientation) //Add new orientation styling

                    let children = e.children //Store interface's children

                    //If element has children
                    if (children) {
                        this.firstChild(children) //Render first child
                    }

                }

            }

            let arr = UI_INTERFACES.concat(UI_ORIENTATION_ELEMENTS_INLINE) //Build array containing element ID's which need inline orientation styling

            //For each element
            arr.forEach((e_) => {

                //If element rendered
                if (document.getElementById(e_) !== null) {

                    let elem = document.getElementById(e_) //Retrieve node

                    elem.classList.remove(o)             //Remove old orientation styling 
                    elem.classList.add(this.orientation) //Add new orientation styling

                    let children = elem.children //Store interface's children
                    this.firstChild(children)    //Render first child

                }

            })

            //If new UI has rendered
            if (document.getElementById('new_betConsoleMobile') && window.newUI) {

                //For each button
                window.newUI.buttons.forEach(b_ => {

                    //Change position in DOM depending on orientation
                    this.orientation === 'landscape' ? document.getElementById(b_.layout).appendChild(b_.elem) : document.getElementById('arch').appendChild(b_.elem)
                
                })

            }

            /** Hacky fix to ensure button texts are styled correctly (sorry) */
            
            let texts = document.getElementsByClassName('text') //Store all button text nodes

            //Loop through texts
            for (let i = 0; i < texts.length; i++) {

                let t = texts[i]                  //Store current text node
                t.classList.remove(o)             //Remove old orientation styling
                t.classList.add(this.orientation) //Add new orientation styling

            }

        }

    }

    /**
     * Handles updating stlying for first child
     * @param {HTMLCollection} children_ - Reference to first child
     */
    firstChild(children_) {

        let o = ORIENTATIONS.filter(o_ => o_ !== this.orientation) //Retrieve old orientation

        //Loop through children nodes
        for (let i = 0; i < children_.length; i++) {

            let child = children_[i] //Store current child

            //If child node has further children
            if (child.children) {
                this.children(child) //Update child nodes styling
            }

            child.classList.remove(o)             //Remove old orientation styling
            child.classList.add(this.orientation) //Add new orientation styling

        }

    }

    /**
     * Handles updating nested children nodes styling
     * @param {HTMLElement} c_ - Reference to child node
     */
    children(c_) {

        let o = ORIENTATIONS.filter(o_ => o_ !== this.orientation) //Retrieve old orientation
        
        //Loop through children nodes
        for (let i = 0; i < c_.children.length; i++) {

            let c = c_.children[i]            //Store current child
            c.classList.remove(o)             //Remove old orientation styling
            c.classList.add(this.orientation) //Add new orientation styling

            //If child has children nodes
            if (c.children !== null) {
                this.children(c) //Update child nodes styling
            }

        }

    }

    /**
     * Check's orientation of device
     * @return {string} Device orientation
     */
    check() {

        //If landscape
        if (window.innerHeight < window.innerWidth) {
            this.orientation = 'landscape' //Set landscape orientation
        }

        //Portrait
        else {
            this.orientation = 'portrait' //Set portrait orientation
        }

        this.style() //Update UI styling

        this.onChange.dispatch(this.orientation) //Dispatch onChange event

        return this.orientation //Return new orientation

    }

}